<template>
  <div>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="2">
          <v-menu transition="scale-transition" offset-y v-model="dateMenu">
            <template v-slot:activator="{ on }">
              <v-text-field label="Month" hide-details dense readonly v-on="on" v-model="monthAsDate" outlined append-icon="mdi-menu-down" @click:append="dateMenu=true"/>
            </template>
            <v-date-picker v-model="month" type="month" no-title @change="refresh"/>
          </v-menu>
        </v-col>
        <v-col cols="2">
          <v-select :items="licenses" label="License" v-model="license" @change="refresh" dense hide-details outlined class="ml-6"/>
        </v-col>
        <v-col cols="5" align-self="center"  offset="1">
          <reports-excise-file-button :month="month"/>
        </v-col>
        <v-col align-self="center">
          <v-btn outlined small @click="rates()">Excise rates</v-btn>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Excise warehouse return',report(true))"><v-icon>mdi-printer</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 180px)">
      <div v-html="report(false)"/>
    </v-card>

    <component :is="exciseRates" v-model="showExciseRates"/>

    <v-dialog v-model="showDetails" width="80%">
      <v-card>
        <v-card-title>
          {{title}}
          <v-spacer/>
          <v-icon @click="showDetails=false">mdi-close</v-icon>
        </v-card-title>
        <v-data-table :items="activityReport" disable-pagination disable-filtering disable-sort
                      fixed-header calculate-widths hide-default-footer height="400" class="pa-4"
                      no-data-text="No activity in period"
                      :headers="[{text:'Date',value:'date',width:'15%'},
                                 {text:'Product',value:'productName',width:'30%'},
                                 {text:'Description',value:'description',width:'35%'},
                                 {text:'LAA',value:'laa',width:'10%',align:'right'},
                                 {text:'Litres',value:'litres',width:'10%',align:'right'}]"
                      @click:row="(e,info) => viewTransaction(info.item)">
          <template v-slot:item.date="{value}">{{value | formatDate}}</template>
          <template v-slot:item.description="{item}">{{item.description}}<div class="text-caption">{{item.comments}}</div></template>
          <template v-slot:item.laa="{item}">
            <template v-if="item.alcoholType === 'Spirit' && item.strength > 7">{{item.laa*factor | number(3)}}</template>
            <template v-else></template>
          </template>
          <template v-slot:item.litres="{item}">
            <template v-if="item.alcoholType !== 'Spirit' || item.strength <= 7">{{item.litres*factor | number(3)}}</template>
            <template v-else></template>
          </template>
          <template v-slot:body.append="{headers}">
            <tr :class="darkMode ? 'total-row-dark' : 'total-row'">
              <template v-for="header of headers">
                <td class="text-right" v-if="header.value==='laa'">
                  {{totalLAA*factor | number(3)}}
                </td>
                <td class="text-right" v-else-if="header.value==='litres'">
                  {{totalLitres*factor | number(3)}}
                </td>
                <td v-else/>
              </template>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {format,add, lastDayOfMonth} from 'date-fns'
import ReportsExciseFileButton from '@/views/reports/excise/ReportsExciseFileButton'
import printHtml from '@/mixins/printHtml'
import viewTransaction from '@/mixins/viewTransaction'

export default {
  name: 'ReportsExciseWarehouse',
  mixins: [printHtml, viewTransaction],
  components: {ReportsExciseFileButton},
  data() {
    return {
      dateMenu: false,
      month: '',
      license: '',
      exciseWarehouseReport: null,
      exciseSpiritsReport: {header:{},lines:[]},
      exciseRates: null,
      showExciseRates: false,
      showDetails: false,
      title: '',
      excise: null,
      productsActivity: null,
      exciseTypes: [{excise:'ProductAdditionDomestic',title:'Domestic non-duty-paid packaged'},
                    {excise:'ProductAdditionImported',title:'Imported non-duty-paid packaged'},
                    {excise:'ProductAdditionReturnedDutyPaid',title:'Returned from Duty-paid sources'},
                    {excise:'ProductAdditionReturnedNonDutyPaid',title:'Returned from Non-duty-paid sources'},
                    {excise:'ProductReductionToRegisteredUsers',title:'Removed for delivery To registered users'},
                    {excise:'ProductReductionToAccreditedReps',title:'Removed for delivery To accredited representatives'},
                    {excise:'ProductReductionToDutyFree',title:'Removed for delivery To duty free shops'},
                    {excise:'ProductReductionToShipsStores',title:'Removed for delivery As ships\' stores'},
                    {excise:'ProductReductionToLicensedUserDomestic',title:'Removed for delivery To licensed users Domestic'},
                    {excise:'ProductReductionToLicensedUserImported',title:'Removed for delivery To licensed users Imported'},
                    {excise:'ProductReductionToOtherExciseWarehouse',title:'Removed for delivery To other excise warehouses'},
                    {excise:'ProductReductionExported',title:'Exported spirits'},
                    {excise:'ProductReductionReturnToSpiritsLicensee',title:'Returned to Spirits Licensee'},
                    {excise:'ProductReductionBreakage',title:'Breakage'},
                    {excise:'ProductReductionForOtherPurpose',title:'Spirits removed for other purposes'},
                    {excise:'ProductReductionDutyPaidPackaged',title:'Packaged (excluding marked special containers)'},
                    {excise:'ProductReductionDutyPaidMSC',title:'Packaged in marked special containers'},
                    {excise:'ProductReductionDutyPaidOtherPurposes',title:'Spirits removed for other purposes'},
                    {excise:'ProductInventoryAdjustment',title:'Inventory adjustments'}]
    }
  },
  computed: {
    monthAsDate() {
      return this.$formatDate(this.month+'-01', 'MMMM, yyyy');
    },
    licenses() {
      return [...new Set(this.$store.getters.sites(true, {B262:true}).map(site => site.warehouseLicense))];
    },
    activityReport() {
      return this.productsActivity?.filter(activity => activity.excise === this.excise)?? [];
    },
    totalLAA() {
      return this.activityReport.reduce((total, activity) => total + (activity.alcoholType === 'Spirit' && activity.strength > 7 ? activity.laa : 0), 0);
    },
    totalLitres() {
      return this.activityReport.reduce((total, activity) => total + (activity.alcoholType !== 'Spirit' || activity.strength <= 7 ? activity.litres : 0), 0);
    },
    factor() {
      return this.excise.startsWith('ProductReduction') ? -1 : 1;
    }
  },
  async created() {
    this.$emit('name', 'Excise Duty Return - Excise Warehouse Licensee')
    this.month = this.$route.query.month ?? format(add(new Date(), {months:-1}), 'yyyy-MM');
    this.license = this.licenses[0];
    this.refresh();
  },
  methods: {
    rates() {
      if (!this.exciseRates)
        this.exciseRates = () => import('@/views/reports/excise/ReportsExciseRates');
      this.showExciseRates = true;
    },
    number(num, precision) {
      return this.$number(num, precision);
    },
    cents(num) {
      let cents = Math.round(Math.abs(num) % 1 * 100);
      return cents < 10 ? '0'+cents : cents;
    },
    laa(excise) {
      const entry = this.exciseWarehouseReport.lines.find(line => line.excise === excise);
      return this.$number(entry ? entry.laa : 0, 3);
    },
    litres(excise) {
      const entry = this.exciseWarehouseReport.lines.find(line => line.excise === excise);
      return this.$number(entry ? entry.litres : 0, 3);
    },
    wineHigh(excise) {
      const entry = this.exciseWarehouseReport.lines.find(line => line.excise === excise);
      return this.$number(entry ? entry.wineHigh : 0, 3);
    },
    wineMedium(excise) {
      const entry = this.exciseWarehouseReport.lines.find(line => line.excise === excise);
      return this.$number(entry ? entry.wineMedium : 0, 3);
    },
    wineLow(excise) {
      const entry = this.exciseWarehouseReport.lines.find(line => line.excise === excise);
      return this.$number(entry ? entry.wineLow : 0, 3);
    },
    async refresh() {
      const results = await this.$apiCall(`query ReportsExciseWarehouse($license:String!,$date:Date!) {
                                            exciseWarehouseReport(license:$license,date:$date) {
                                              laa {openingInventory,totalAdditions,totalNonDutyReductions,totalDutyReductions,totalReductions,closingInventory,excisePayable},
                                              litres {openingInventory,totalAdditions,totalNonDutyReductions,totalDutyReductions,totalReductions,closingInventory,excisePayable},
                                              wineLow {openingInventory,totalAdditions,totalNonDutyReductions,totalDutyReductions,totalReductions,closingInventory,excisePayable},
                                              wineMedium {openingInventory,totalAdditions,totalNonDutyReductions,totalDutyReductions,totalReductions,closingInventory,excisePayable},
                                              wineHigh {openingInventory,totalAdditions,totalNonDutyReductions,totalDutyReductions,totalReductions,closingInventory,excisePayable},
                                              lines{excise,laa,litres,wineLow,wineMedium,wineHigh},
                                              excisePayable,exciseRefunds,exciseNet
                                              b256 {quantity,rate,amount}
                                              header {businessName,mailingAddress,city,province,postalCode,
                                                      accountNumber,accountNumberSuffix,
                                                      periodFrom,periodTo,dueDate}
                                            }
                                          }`,
                                          {license:this.license,date:this.month+'-01'});
      if (!results.error)
        this.exciseWarehouseReport = results.data.exciseWarehouseReport;
      this.productsActivity = null;
    },
    async details(excise) {
      if (!this.productsActivity) {
        let to = format(lastDayOfMonth(add(new Date(this.month+'-01'),{days:1})), 'yyyy-MM-dd');
        const results = await this.$apiCall(`query ReportsExciseSpirits($license:String!,$date:Date!,$to:Date!) {
                                                productsActivity(from:$date,to:$to,license:$license,inBond:true) {
                                                  date,description,litres,laa,strength,productName,excise,comments,refType,refId,alcoholType
                                                }
                                              }`,
                                            {license:this.license,date:`${this.month}-01`,to});
        if (!results.error)
          this.productsActivity = results.data.productsActivity;
      }
      this.excise = excise;
      this.title = this.exciseTypes.find(exciseType => exciseType.excise === excise).title;
      this.showDetails = true;
    },

    report(print) {
      if (!this.exciseWarehouseReport)
        return '';

      const report = `
        <style>
          @page {size:portrait}
          @media print {
            .report table {
              font-size: 10px;
            }
            .page-break {
              page-break-before: always;
            }
          }
          @media screen {
            .page-break {
              border-top:thin solid #ccc;
              margin-top: 50px;
              margin-bottom: 50px;
            }
          }
          .report {
            font-family: Roboto, sans-serif;
            font-size:12px;
          }
          .report-title {font-size:120%;font-weight:bold; text-align:center}
          .report-sub-title {font-size:110%;text-align:center}
          .report table {
            margin-top:20px;
            border-collapse:collapse;
            width:100%;
          }
          .report table td {
            border:thin solid black;
            height:25px;
            padding:4px;
            white-space: nowrap;
            vertical-align: middle;
          }

          .page-1 .header td:nth-child(3) {padding:0}
          .page-1 .header td:nth-child(6) {padding:0}
          .page-1 .header {
            text-align:center
          }
          .page-1 .line td:nth-child(1) {width:50%}
          .page-1 .line td:nth-child(2) {width:20%;text-align:right}
          .page-1 .line td:nth-child(3) {width:5%;font-weight:bold;text-align:center}
          .page-1 .line td:nth-child(4) {width:20%;text-align:right}
          .page-1 .line td:nth-child(5) {width:5%;padding:0;font-weight:bold;text-align:center;padding:0}
          .page-1 .total td:nth-child(1) {border:none;text-align:right;font-weight:bold}
          .page-1 .total td:nth-child(2) {text-align:right}
          .page-1 .total td:nth-child(3) {padding:0;font-weight:bold;text-align:center;padding:0}
          .page-1 .line:not(.first-line) td:nth-child(4):before {float:left;font-weight:bold;content:'+'}
          .page-1 .total td:nth-child(2):before {float:left;font-weight:bold;content:'='}

          .spirits td:nth-child(1) {width:40%;padding-left:12px}
          .spirits td:nth-child(2) {width:25%;text-align:right}
          .spirits td:nth-child(3) {width:25%;text-align:right}
          .spirits td:nth-child(4) {width:10%;font-weight:bold;border:none}
          .spirits .header td:nth-child(1) {border:none}
          .spirits .header td:nth-child(2) {text-align:center}
          .spirits .header td:nth-child(3) {text-align:center;background-color:#fff}
          .spirits .header td:nth-child(4) {border:none}
          .spirits .top-header td {border:none}
          .spirits .sub-header td:nth-child(1) {font-weight:bold;padding-left:0}
          .spirits .sub-header td:nth-child(2) {border:none}
          .spirits .total td:nth-child(1) {font-weight:bold;text-align:right;border:none}
          .spirits .line:not(.sub-header,.first-line) td:nth-child(2):before {float:left;font-weight:bold;content:'+'}
          .spirits .total:not(.first-line) td:nth-child(2):before {float:left;font-weight:bold;content:'='}
          .spirits .line:not(.sub-header,.first-line) td:nth-child(3):before {float:left;font-weight:bold;content:'+'}
          .spirits .total:not(.first-line) td:nth-child(3):before {float:left;font-weight:bold;content:'='}
          .spirits .line:not(.sub-header) td:nth-child(2) {cursor:pointer}
          .spirits .line:not(.sub-header) td:nth-child(3) {cursor:pointer}
          .spirits .line:not(.sub-header) td:nth-child(2):hover {background-color:#eee}
          .spirits .line:not(.sub-header) td:nth-child(3):hover {background-color:#eee}

          .wine td:nth-child(1) {width:47%;padding-left:12px}
          .wine td:nth-child(2) {width:17%;text-align:right}
          .wine td:nth-child(3) {width:17%;text-align:right}
          .wine td:nth-child(4) {width:17%;text-align:right}
          .wine td:nth-child(5) {width:10%;font-weight:bold;border:none}
          .wine .header td:nth-child(1) {border:none}
          .wine .header td:nth-child(2) {text-align:center}
          .wine .header td:nth-child(3) {text-align:center;background-color:#fff}
          .wine .header td:nth-child(4) {text-align:center;background-color:#fff}
          .wine .header td:nth-child(5) {border:none;background-color:#fff}
          .wine .top-header td {border:none}
          .wine .sub-header td:nth-child(1) {font-weight:bold;padding-left:0}
          .wine .sub-header td:nth-child(2) {border:none}
          .wine .total td:nth-child(1) {font-weight:bold;text-align:right;border:none}
          .wine .line:not(.sub-header,.first-line) td:nth-child(2):before {float:left;font-weight:bold;content:'+'}
          .wine .total:not(.first-line) td:nth-child(2):before {float:left;font-weight:bold;content:'='}
          .wine .line:not(.sub-header,.first-line) td:nth-child(3):before {float:left;font-weight:bold;content:'+'}
          .wine .total:not(.first-line) td:nth-child(3):before {float:left;font-weight:bold;content:'='}
          .wine .line:not(.sub-header,.first-line) td:nth-child(4):before {float:left;font-weight:bold;content:'+'}
          .wine .total:not(.first-line) td:nth-child(4):before {float:left;font-weight:bold;content:'='}
          .wine .line:not(.sub-header) td:nth-child(2) {cursor:pointer}
          .wine .line:not(.sub-header) td:nth-child(3) {cursor:pointer}
          .wine .line:not(.sub-header) td:nth-child(4) {cursor:pointer}
          .wine .line:not(.sub-header) td:nth-child(2):hover {background-color:#eee}
          .wine .line:not(.sub-header) td:nth-child(3):hover {background-color:#eee}
          .wine .line:not(.sub-header) td:nth-child(4):hover {background-color:#eee}

          .pointer: {cursor:point}
          .pointer:hover {background-color:#eee}
        </style>
        <div class="report">
          ${this.reportPage1()}
          <div class="page-break"/>
          ${this.reportSpirits()}
          <div class="page-break"/>
          ${this.reportWine()}
          ${this.reportB256()}
        </div>
      `;

      if (!print)
        this.$nextTick( () =>
          this.exciseTypes.forEach(exciseType => {
            document.getElementById(exciseType.excise).addEventListener("click", () => this.details(exciseType.excise));
            document.getElementById(`${exciseType.excise}L`).addEventListener("click", () => this.details(exciseType.excise));
            try {
              document.getElementById(`${exciseType.excise}WL`).addEventListener("click", () => this.details(exciseType.excise));
              document.getElementById(`${exciseType.excise}WM`).addEventListener("click", () => this.details(exciseType.excise));
              document.getElementById(`${exciseType.excise}WH`).addEventListener("click", () => this.details(exciseType.excise));
            } catch (error) {
              // wine does not have all excise types
            }
          })
        )

      return report;
    },

    reportPage1() {
      return `
          <div class="report-title">Excise Duty Return – Excise Warehouse Licensee</div>
          <div class="report-sub-title">Account number ${this.exciseWarehouseReport.header.accountNumber||''} RD ${this.exciseWarehouseReport.header.accountNumberSuffix}</div>
          <div class="report-sub-title">${this.exciseWarehouseReport.header.periodFrom} to ${this.exciseWarehouseReport.header.periodTo}</div>
          <table class="page-1">
            <tr class="header">
              <td><b>Products</b><br/>(according to percentage of absolute ethyl alcohol by volume)</td>
              <td><b>Quantity</b><br/>(Litres of absolute ethyl<br/>alcohol/Litres)</td>
              <td><b>Code</b></td>
              <td colspan="2"><b>Duty payable</b></td>
            </tr>
            <tr class="line first-line">
              <td>Spirits containing more than 7%</td>
              <td>${this.number(this.exciseWarehouseReport.laa.totalDutyReductions,3)}</td>
              <td>49540</td>
              <td>${this.number(this.exciseWarehouseReport.laa.excisePayable,2)}</td>
              <td>4</td>
            </tr>
            <tr class="line">
              <td>Spirits containing not more than 7%</td>
              <td>${this.number(this.exciseWarehouseReport.litres.totalDutyReductions,3)}</td>
              <td>49542</td>
              <td>${this.number(this.exciseWarehouseReport.litres.excisePayable,2)}</td>
              <td>5</td>
            </tr>
            <tr class="line">
              <td>Imported spirits delivered to licensed users</td>
              <td>0.000</td>
              <td>49571</td>
              <td>0.00</td>
              <td>6</td>
            </tr>
            <tr class="line">
              <td>Wine containing more than 7%</td>
              <td>${this.number(this.exciseWarehouseReport.wineHigh.totalDutyReductions,3)}</td>
              <td>49570</td>
              <td>${this.number(this.exciseWarehouseReport.wineHigh.excisePayable,2)}</td>
              <td>7</td>
            </tr>
            <tr class="line">
              <td>Wine containing more than 1.2%, but not more than 7%</td>
              <td>${this.number(this.exciseWarehouseReport.wineMedium.totalDutyReductions,3)}</td>
              <td>49569</td>
              <td>${this.number(this.exciseWarehouseReport.wineMedium.excisePayable,2)}</td>
              <td>8</td>
            </tr>
            <tr class="line">
              <td>Wine containing not more than 1.2%</td>
              <td>${this.number(this.exciseWarehouseReport.wineLow.totalDutyReductions,3)}</td>
              <td>49568</td>
              <td>${this.number(this.exciseWarehouseReport.wineLow.excisePayable,2)}</td>
              <td>9</td>
            </tr>
            <tr class="total">
              <td colspan="3">Total (4 to 9) ►</td>
              <td>${this.number(this.exciseWarehouseReport.excisePayable,2)}</td>
              <td>10</td>
            </tr>
            <tr class="total"><td/></tr>
            <tr class="total">
              <td colspan="3">Refunds (B256 attached)</td>
              <td>${this.number(this.exciseWarehouseReport.exciseRefunds,2)}</td>
              <td>11</td>
            </tr>
            <tr class="total"><td/></tr>
            <tr class="total">
              <td colspan="3">Net payable (line 10 minus line 11)</td>
              <td>${this.number(this.exciseWarehouseReport.exciseNet,2)}</td>
              <td>12</td>
            </tr>
            <tr class="total"><td/></tr>
            <tr class="total">
              <td colspan="3">Amount due</td>
              <td>${this.number(this.exciseWarehouseReport.exciseNet < 0 ? 0 : this.exciseWarehouseReport.exciseNet,2)}</td>
              <td>13</td>
            </tr>
            <tr class="total"><td/></tr>
            <tr class="total">
              <td colspan="3">Payment / Credit due</td>
              <td>${this.number(this.exciseWarehouseReport.exciseNet,2)}</td>
              <td>14</td>
            </tr>
          </table>
      `;
    },

    reportSpirits() {
      return `
          <table class="spirits">
            <tr class="header top-header">
              <td/>
              <td colspan="2"><b>Spirits</b></td>
              <td/>
            </tr>
            <tr class="header">
              <td/>
              <td><b>Containing more than 7%</b><br/>Litres absolute ethyl alcohol</td>
              <td><b>Containing not more than 7%</b><br/>Litres</td>
              <td/>
            </tr>
            <tr class="total first-line">
              <td>Opening inventory ►</td>
              <td>${this.number(this.exciseWarehouseReport.laa.openingInventory,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.litres.openingInventory,3)}</td>
              <td>A)</td>
            </tr>
            <tr class="line sub-header">
              <td colspan="3">Additions to inventory</td>
              <td>&nbsp;</td>
            </tr>
            <tr class="line first-line">
              <td>Domestic non-duty-paid packaged</td>
              <td id="ProductAdditionDomestic">${this.laa('ProductAdditionDomestic')}</td>
              <td id="ProductAdditionDomesticL">${this.litres('ProductAdditionDomestic')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Imported non-duty-paid packaged</td>
              <td id="ProductAdditionImported">${this.laa('ProductAdditionImported')}</td>
              <td id="ProductAdditionImportedL">${this.litres('ProductAdditionImported')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Returned from duty-paid sources</td>
              <td id="ProductAdditionReturnedDutyPaid">${this.laa('ProductAdditionReturnedDutyPaid')}</td>
              <td id="ProductAdditionReturnedDutyPaidL">${this.litres('ProductAdditionReturnedDutyPaid')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Returned from non-duty-paid sources</td>
              <td id="ProductAdditionReturnedNonDutyPaid">${this.laa('ProductAdditionReturnedNonDutyPaid')}</td>
              <td id="ProductAdditionReturnedNonDutyPaidL">${this.litres('ProductAdditionReturnedNonDutyPaid')}</td>
              <td/>
            </tr>
            <tr class="total">
              <td>Total additions ►</td>
              <td>${this.number(this.exciseWarehouseReport.laa.totalAdditions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.litres.totalAdditions,3)}</td>
              <td>B)</td>
            </tr>
            <tr class="line sub-header">
              <td colspan="3">Reductions to inventory: non-duty-paid</td>
              <td>&nbsp;</td>
            </tr>
            <tr class="line first-line">
              <td>Removed for delivery to registered users</td>
              <td id="ProductReductionToRegisteredUsers">${this.laa('ProductReductionToRegisteredUsers')}</td>
              <td id="ProductReductionToRegisteredUsersL">${this.litres('ProductReductionToRegisteredUsers')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Removed for delivery to accredited representatives</td>
              <td id="ProductReductionToAccreditedReps">${this.laa('ProductReductionToAccreditedReps')}</td>
              <td id="ProductReductionToAccreditedRepsL">${this.litres('ProductReductionToAccreditedReps')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Removed for delivery to duty free shops</td>
              <td id="ProductReductionToDutyFree">${this.laa('ProductReductionToDutyFree')}</td>
              <td id="ProductReductionToDutyFreeL">${this.litres('ProductReductionToDutyFree')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Removed for delivery as ships' stores</td>
              <td id="ProductReductionToShipsStores">${this.laa('ProductReductionToShipsStores')}</td>
              <td id="ProductReductionToShipsStoresL">${this.litres('ProductReductionToShipsStores')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Removed for delivery to licensed users - Domestic</td>
              <td id="ProductReductionToLicensedUserDomestic">${this.laa('ProductReductionToLicensedUserDomestic')}</td>
              <td id="ProductReductionToLicensedUserDomesticL">${this.litres('ProductReductionToLicensedUserDomestic')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Removed for delivery to licensed users - Imported</td>
              <td id="ProductReductionToLicensedUserImported">${this.laa('ProductReductionToLicensedUserImported')}</td>
              <td id="ProductReductionToLicensedUserImportedL">${this.litres('ProductReductionToLicensedUserImported')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Removed for delivery to other excise warehouses</td>
              <td id="ProductReductionToOtherExciseWarehouse">${this.laa('ProductReductionToOtherExciseWarehouse')}</td>
              <td id="ProductReductionToOtherExciseWarehouseL">${this.litres('ProductReductionToOtherExciseWarehouse')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Exported spirits</td>
              <td id="ProductReductionExported">${this.laa('ProductReductionExported')}</td>
              <td id="ProductReductionExportedL">${this.litres('ProductReductionExported')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Returned to Spirits Licensee</td>
              <td id="ProductReductionReturnToSpiritsLicensee">${this.laa('ProductReductionReturnToSpiritsLicensee')}</td>
              <td id="ProductReductionReturnToSpiritsLicenseeL">${this.litres('ProductReductionReturnToSpiritsLicensee')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Breakage</td>
              <td id="ProductReductionBreakage">${this.laa('ProductReductionBreakage')}</td>
              <td id="ProductReductionBreakageL">${this.litres('ProductReductionBreakage')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Spirits removed for other purposes (specify)</td>
              <td id="ProductReductionForOtherPurpose">${this.laa('ProductReductionForOtherPurpose')}</td>
              <td id="ProductReductionForOtherPurposeL">${this.litres('ProductReductionForOtherPurpose')}</td>
              <td/>
            </tr>
            <tr class="total">
              <td>Total non-duty-paid reductions ►</td>
              <td>${this.number(this.exciseWarehouseReport.laa.totalNonDutyReductions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.litres.totalNonDutyReductions,3)}</td>
              <td>C)</td>
            </tr>

            <tr class="line sub-header">
              <td colspan="3">Reductions to inventory: duty-paid</td>
              <td>&nbsp;</td>
            </tr>
            <tr class="line first-line">
              <td>Packaged (excluding marked special containers)</td>
              <td id="ProductReductionDutyPaidPackaged">${this.laa('ProductReductionDutyPaidPackaged')}</td>
              <td id="ProductReductionDutyPaidPackagedL">${this.litres('ProductReductionDutyPaidPackaged')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Packaged in marked special containers</td>
              <td id="ProductReductionDutyPaidMSC">${this.laa('ProductReductionDutyPaidMSC')}</td>
              <td id="ProductReductionDutyPaidMSCL">${this.litres('ProductReductionDutyPaidMSC')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Spirits removed for other purposes (specify)</td>
              <td id="ProductReductionDutyPaidOtherPurposes">${this.laa('ProductReductionDutyPaidOtherPurposes')}</td>
              <td id="ProductReductionDutyPaidOtherPurposesL">${this.litres('ProductProductReductionDutyPaidOtherPurposesReductionDutyPaidMSC')}</td>
              <td/>
            </tr>
            <tr class="total">
              <td>Total duty-paid reductions ►</td>
              <td>${this.number(this.exciseWarehouseReport.laa.totalDutyReductions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.litres.totalDutyReductions,3)}</td>
              <td>D)</td>
            </tr>
            <tr class="total"><td/></tr>

            <tr class="total">
              <td>Total reductions (C + D) ►</td>
              <td>${this.number(this.exciseWarehouseReport.laa.totalReductions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.litres.totalReductions,3)}</td>
              <td>E)</td>
            </tr>
            <tr class="total"><td/></tr>
            <tr class="total">
              <td>Inventory adjustments (+ or – ) ►</td>
              <td class="pointer" id="ProductInventoryAdjustment">${this.laa('ProductInventoryAdjustment')}</td>
              <td class="pointer" id="ProductInventoryAdjustmentL">${this.litres('ProductInventoryAdjustment')}</td>
              <td>F)</td>
            </tr>
            <tr class="total"><td/></tr>
            <tr class="total">
              <td>Closing inventory (A +B) – E ± F ►</td>
              <td>${this.number(this.exciseWarehouseReport.laa.closingInventory,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.litres.closingInventory,3)}</td>
              <td>G)</td>
            </tr>
          </table>
      `;
    },

    reportWine() {
      return `
          <table class="wine">
            <tr class="header top-header">
              <td/>
              <td colspan="3"><b>Wine</b></td>
              <td/>
            </tr>
            <tr class="header">
              <td/>
              <td><b>Containing more than 7%</b><br/>Litres</td>
              <td><b>Containing more than<br/>1.2%, but not more than<br/>7%</b><br/>Litres</td>
              <td><b>Containing not more<br/>than 1.2%</b><br/>Litres</td>
              <td/>
            </tr>
            <tr class="total first-line">
              <td>Opening inventory ►</td>
              <td>${this.number(this.exciseWarehouseReport.wineHigh.openingInventory,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineMedium.openingInventory,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineLow.openingInventory,3)}</td>
              <td>A)</td>
            </tr>
            <tr class="line sub-header">
              <td colspan="4">Additions to inventory</td>
              <td>&nbsp;</td>
            </tr>
            <tr class="line first-line">
              <td>Domestic wine</td>
              <td id="ProductAdditionDomesticWH">${this.wineHigh('ProductAdditionDomestic')}</td>
              <td id="ProductAdditionDomesticWM">${this.wineMedium('ProductAdditionDomestic')}</td>
              <td id="ProductAdditionDomesticWL">${this.wineLow('ProductAdditionDomestic')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Imported wine</td>
              <td id="ProductAdditionImportedWH">${this.wineHigh('ProductAdditionImported')}</td>
              <td id="ProductAdditionImportedWM">${this.wineMedium('ProductAdditionImported')}</td>
              <td id="ProductAdditionImportedWL">${this.wineLow('ProductAdditionImported')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Returned from duty-paid sources</td>
              <td id="ProductAdditionReturnedDutyPaidWH">${this.wineHigh('ProductAdditionReturnedDutyPaid')}</td>
              <td id="ProductAdditionReturnedDutyPaidWM">${this.wineMedium('ProductAdditionReturnedDutyPaid')}</td>
              <td id="ProductAdditionReturnedDutyPaidWL">${this.wineLow('ProductAdditionReturnedDutyPaid')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Returned from non-duty-paid sources</td>
              <td id="ProductAdditionReturnedNonDutyPaidWH">${this.wineHigh('ProductAdditionReturnedNonDutyPaid')}</td>
              <td id="ProductAdditionReturnedNonDutyPaidWM">${this.wineMedium('ProductAdditionReturnedNonDutyPaid')}</td>
              <td id="ProductAdditionReturnedNonDutyPaidWL">${this.wineLow('ProductAdditionReturnedNonDutyPaid')}</td>
              <td/>
            </tr>
            <tr class="total">
              <td>Total additions ►</td>
              <td>${this.number(this.exciseWarehouseReport.wineHigh.totalAdditions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineMedium.totalAdditions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineLow.totalAdditions,3)}</td>
              <td>B)</td>
            </tr>

            <tr class="line sub-header">
              <td colspan="4">Reductions to inventory: non-duty-paid</td>
              <td>&nbsp;</td>
            </tr>
            <tr class="line first-line">
              <td>Removed for delivery to accredited representatives</td>
              <td id="ProductReductionToAccreditedRepsWH">${this.wineHigh('ProductReductionToAccreditedReps')}</td>
              <td id="ProductReductionToAccreditedRepsWM">${this.wineMedium('ProductReductionToAccreditedReps')}</td>
              <td id="ProductReductionToAccreditedRepsWL">${this.wineLow('ProductReductionToAccreditedReps')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Removed for delivery to duty free shops</td>
              <td id="ProductReductionToDutyFreeWH">${this.wineHigh('ProductReductionToDutyFree')}</td>
              <td id="ProductReductionToDutyFreeWM">${this.wineMedium('ProductReductionToDutyFree')}</td>
              <td id="ProductReductionToDutyFreeWL">${this.wineLow('ProductReductionToDutyFree')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Removed for delivery as ships' stores</td>
              <td id="ProductReductionToShipsStoresWH">${this.wineHigh('ProductReductionToShipsStores')}</td>
              <td id="ProductReductionToShipsStoresWM">${this.wineMedium('ProductReductionToShipsStores')}</td>
              <td id="ProductReductionToShipsStoresWL">${this.wineLow('ProductReductionToShipsStores')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Removed for delivery to licensed users</td>
              <td id="ProductReductionToLicensedUserDomesticWH">${this.wineHigh('ProductReductionToLicensedUserDomestic')}</td>
              <td id="ProductReductionToLicensedUserDomesticWM">${this.wineMedium('ProductReductionToLicensedUserDomestic')}</td>
              <td id="ProductReductionToLicensedUserDomesticWL">${this.wineLow('ProductReductionToLicensedUserDomestic')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Removed for delivery to other excise warehouses</td>
              <td id="ProductReductionToOtherExciseWarehouseWH">${this.wineHigh('ProductReductionToOtherExciseWarehouse')}</td>
              <td id="ProductReductionToOtherExciseWarehouseWM">${this.wineMedium('ProductReductionToOtherExciseWarehouse')}</td>
              <td id="ProductReductionToOtherExciseWarehouseWL">${this.wineLow('ProductReductionToOtherExciseWarehouse')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Exported wine</td>
              <td id="ProductReductionExportedWH">${this.wineHigh('ProductReductionExported')}</td>
              <td id="ProductReductionExportedWM">${this.wineMedium('ProductReductionExported')}</td>
              <td id="ProductReductionExportedWL">${this.wineLow('ProductReductionExported')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Returned to wine licensee</td>
              <td id="ProductReductionReturnToSpiritsLicenseeWH">${this.wineHigh('ProductReductionReturnToSpiritsLicensee')}</td>
              <td id="ProductReductionReturnToSpiritsLicenseeWM">${this.wineMedium('ProductReductionReturnToSpiritsLicensee')}</td>
              <td id="ProductReductionReturnToSpiritsLicenseeWL">${this.wineLow('ProductReductionReturnToSpiritsLicensee')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Breakage</td>
              <td id="ProductReductionBreakageWH">${this.wineHigh('ProductReductionBreakage')}</td>
              <td id="ProductReductionBreakageWM">${this.wineMedium('ProductReductionBreakage')}</td>
              <td id="ProductReductionBreakageWL">${this.wineLow('ProductReductionBreakage')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Wine removed for other purposes (specify)</td>
              <td id="ProductReductionForOtherPurposeWH">${this.wineHigh('ProductReductionForOtherPurpose')}</td>
              <td id="ProductReductionForOtherPurposeWM">${this.wineMedium('ProductReductionForOtherPurpose')}</td>
              <td id="ProductReductionForOtherPurposeWL">${this.wineLow('ProductReductionForOtherPurpose')}</td>
              <td/>
            </tr>
            <tr class="total">
              <td>Total non-duty-paid reductions ►</td>
              <td>${this.number(this.exciseWarehouseReport.wineHigh.totalNonDutyReductions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineMedium.totalNonDutyReductions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineLow.totalNonDutyReductions,3)}</td>
              <td>C)</td>
            </tr>

            <tr class="line sub-header">
              <td colspan="4">Reductions to inventory: duty-paid</td>
              <td>&nbsp;</td>
            </tr>
            <tr class="line first-line">
              <td>Packaged (excluding marked special containers)</td>
              <td id="ProductReductionDutyPaidPackagedWH">${this.wineHigh('ProductReductionDutyPaidPackaged')}</td>
              <td id="ProductReductionDutyPaidPackagedWM">${this.wineMedium('ProductReductionDutyPaidPackaged')}</td>
              <td id="ProductReductionDutyPaidPackagedWL">${this.wineLow('ProductReductionDutyPaidPackaged')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Packaged in marked special containers</td>
              <td id="ProductReductionDutyPaidMSCWH">${this.wineHigh('ProductReductionDutyPaidMSC')}</td>
              <td id="ProductReductionDutyPaidMSCWM">${this.wineMedium('ProductReductionDutyPaidMSC')}</td>
              <td id="ProductReductionDutyPaidMSCWM">${this.wineLow('ProductReductionDutyPaidMSC')}</td>
              <td/>
            </tr>
            <tr class="line">
              <td>Wine removed for other purposes (specify)</td>
              <td id="ProductReductionDutyPaidOtherPurposesWH">${this.wineHigh('ProductReductionDutyPaidOtherPurposes')}</td>
              <td id="ProductReductionDutyPaidOtherPurposesWM">${this.wineMedium('ProductProductReductionDutyPaidOtherPurposesReductionDutyPaidMSC')}</td>
              <td id="ProductReductionDutyPaidOtherPurposesWM">${this.wineLow('ProductProductReductionDutyPaidOtherPurposesReductionDutyPaidMSC')}</td>
              <td/>
            </tr>
            <tr class="total">
              <td>Total duty-paid reductions ►</td>
              <td>${this.number(this.exciseWarehouseReport.wineHigh.totalDutyReductions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineMedium.totalDutyReductions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineLow.totalDutyReductions,3)}</td>
              <td>D)</td>
            </tr>
            <tr class="total"><td/></tr>

            <tr class="total">
              <td>Total reductions (C + D) ►</td>
              <td>${this.number(this.exciseWarehouseReport.wineHigh.totalReductions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineMedium.totalReductions,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineLow.totalReductions,3)}</td>
              <td>E)</td>
            </tr>
            <tr class="total"><td/></tr>
            <tr class="total">
              <td>Inventory adjustments (+ or – ) ►</td>
              <td class="pointer" id="ProductInventoryAdjustmentWH">${this.wineHigh('ProductInventoryAdjustment')}</td>
              <td class="pointer" id="ProductInventoryAdjustmentWM">${this.wineMedium('ProductInventoryAdjustment')}</td>
              <td class="pointer" id="ProductInventoryAdjustmentWL">${this.wineLow('ProductInventoryAdjustment')}</td>
              <td>F)</td>
            </tr>
            <tr class="total"><td/></tr>
            <tr class="total">
              <td>Closing inventory (A +B) – E ± F ►</td>
              <td>${this.number(this.exciseWarehouseReport.wineHigh.closingInventory,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineMedium.closingInventory,3)}</td>
              <td>${this.number(this.exciseWarehouseReport.wineLow.closingInventory,3)}</td>
              <td>G)</td>
            </tr>
          </table>
      `;
    },

    reportB256() {
      if (!this.exciseWarehouseReport.b256.length)
        return '';
      let b256 = `<div class="page-break"/>
                    <table>
                      <thead>
                        <tr>
                          <th colspan="4" class="title">Excise Act, 2001</th>
                        </tr>
                        <tr>
                          <th colspan="4" class="title">Application for Refund</th>
                        </tr>
                        <tr>
                          <th colspan="4" class="title">B256 Information</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td colspan="4"/></tr>
                        <tr>
                          <td>Refund code</td>
                          <td style="text-align:right">Quantity</td>
                          <td style="text-align:right">Rate</td>
                          <td style="text-align:right">Amount claimed</td>
                        </tr>`;
      for (const line of this.exciseWarehouseReport.b256)
        b256 += ` <tr>
                    <td>${line.quantity.includes('LAA') ? '4958801' : '4958901'}</td>
                    <td style="text-align:right">${line.quantity}</td>
                    <td style="text-align:right">${line.rate}</td>
                    <td style="text-align:right">${this.number(line.amount,2)}</td>
                  </tr>`;
      b256 += `  <tr>
                  <td colspan="4"><a href="https://www.canada.ca/content/dam/cra-arc/formspubs/pbg/b256/b256-fill-21e.pdf" target="_blank">Download B256</a></td>
                  </tr>
                </tbody>
              </table>`;
      return b256;
    }
  }
}
</script>